// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import { timeToClosedToast } from '../../../commons';
import { storeEditArea } from '../../../store/areas';
import MultipleSnackbars from '../../MultipleSnackbars';
import { EditarTerminal } from '../../terminal/editar/EditarTerminal';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import { closeSessionGlobal, hasPemissions } from '../../../commons/utils';
// import validationSchema from '../../areas/formModels/editar/validationSchema';
// import formInitialValues from '../../areas/formModels/editar/formInitialValues';
// import editarAreaFormModel from '../../areas/formModels/editar/editarAreaFormModel';
import { storeEditTerminal } from '../../../store/terminals';
import editarTerminalFormModel from '../../terminal/formModels/editar/editarTerminalFormModel';
import validationSchema from '../../terminal/formModels/editar/validationSchema';
import formInitialValues from '../../terminal/formModels/editar/formInitialValues';





const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));





export const EditarDialogTerminal = (props:any) =>  {


  // USE DISPATCH 
  const dispatch = useDispatch();

  
  // USE STATE 
  const [canEdit, setCanEdit]     = React.useState<boolean>(false);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [txtBtnEditTerminal, setTxtBtnEditTerminal] = React.useState<string>('Editar Terminal');

  const [msgSnack, setMsgSnack] = React.useState({
     msg: '',
     status: 'success'
  });

  


  // PROPS 
  const{ open, handleCloseModalEditar, buttons = false, btnSubmiting } = props;

  // DATA MODELS  
  const { formId, formField } = editarTerminalFormModel;
  const currentValidationSchema = validationSchema[0];

 
  // USE EFFECT 
  React.useEffect(() => {
      checkEdit()
  }, [props]);

  React.useEffect(() => {
     setIsSubmiting(!open);
  }, [props]);
  


  
  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalEditar(false);
  };


  const checkEdit = async() => {
  
      const hasPermissionsEdit = await hasPemissions('modulo.configuracion', 'modulo.terminales', 'edit' );
    
      if ( hasPermissionsEdit ) {
            setCanEdit(true);
      }
  }


  const validateResponse = async(response:any, textActionConcat: string) => {
  
  
          if (  response.code == 401  ) {
            await localStorage.removeItem('lastSelectedQypht');
            await closeSessionGlobal();
            await handleCloseModalEditar(false);
            setModalSessionExpired(true);
            return false;
          }
  
       
          // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
          if (!response.ok && response.code == 403 ) { 
  
            const errors:any = {
                msg: response.errors[0]+' '+textActionConcat,
                status: 'error'
            };
            
            await setMsgSnack(errors);
            await setAlertSnack(true);
  
            return false;
          }
  
          
          // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
          if (!response.ok && response.code == 400 ) { 
  
            const errors:any = [];
  
            response.errors.forEach( (element:any) => {
                
                errors.push({
                  type: 'error',
                  text: element
                });
            });
  
              
            setMessagesAlerts(errors);
            return false;
  
          }
  
          return true;
        
  }


  const _handleSubmit = async(values:any, actions:any) => {



    setTxtBtnEditTerminal('Un Monento...')
    actions.setSubmitting(true);
    setIsSubmiting(true);
    const response = await dispatch( storeEditTerminal(values) );

    setTxtBtnEditTerminal('Editar Terminal')
    const result = await validateResponse(response, ' (Editar Terminal) ');

    setIsSubmiting(false);

    if (!result) {
        return false;
    }

    

    if (response.ok) {

      const errors:any = {
        msg: 'Terminal Editada Con Exito',
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);

      actions.setSubmitting(false);
      handleCloseModalEditar(false);
    }
    
   
    

  }
  
  

  return (
    <React.Fragment>

      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Editar Terminal
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
        <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
              <Form id={formId}>
                <EditarTerminal formField={formField}/>
                 
                {
                  canEdit &&  <Button
                                disabled={isSubmiting}
                                style={{margin:5, float: 'right'}}
                                type="submit"
                                variant="contained"
                                color={ "primary"}
                              >
                                {
                                  txtBtnEditTerminal
                                }
                              </Button>
                }
                
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}




